module.exports = __webpack_public_path__ + "img/symbol_13_x8.a655cef5.png";